import { ServingLine } from '@/models';

export class ServingLineViewModel {
  servingLine: ServingLine;

  constructor(model: ServingLine) {
    this.servingLine = model;
  }

  get servedByFullName() {
    return `${this.servingLine.servedByFirstName} ${this.servingLine.servedByLastName}`.trim();
  }
  
  get isMerged() {
    return this.servingLine.mergedIntoTrackingId !== undefined;
  }
}
